import { ICommand, Topics } from '@zaplify/common';
import { PersonFilterDto } from '../dtos';

export class CreateProspectSearchCommand extends ICommand<PersonFilterDto> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly personFilterDto: Omit<PersonFilterDto, 'id'>) {
        super();
    }
}
